export default "__VITE_ASSET__8ed0544f__"